<template>
  <div :class="{questionnaire_detail_box:true,show_operate:detailInfo.status == 2}">
    <div class="questionnaire_pic">
      <img :src="detailInfo.focusPicUrl" alt="" v-if="!!detailInfo.focusPicUrl && detailInfo.focusPicUrl.length > 0" />
    </div>
    <div class="detail_box">
      <div class="questionnaire_title" v-text="detailInfo.title"></div>
      <div class="questionnaire_comp">
        <span class="part_num">
          <Icon iconClass="users" />已有<span v-text="detailInfo.participateNumber" v-if="detailInfo.status == 2||detailInfo.status == 3"></span><span v-else>0</span>人参加
        </span>
        <span class="questionnaire_status ongoing" v-if="detailInfo.status == 2">正在进行</span>
        <span class="questionnaire_status over" v-else-if="detailInfo.status == 3">已经结束</span>
        <span class="questionnaire_status not_start" v-else>即将开始</span>
      </div>
      <div class="questionnaire_time">
        <div class="time">
          <Icon iconClass="time" />
          <span class="start_time" v-text="detailInfo.startDate + ' ' + detailInfo.startTime"></span>
          <span> - </span>
          <span class="end_time" v-text="detailInfo.endDate + ' ' + detailInfo.endTime"></span>
        </div>
      </div>
    </div>
    <div class="questionnaire_description_box" v-if="detailInfo.introduction.length>0">
      <div class="description_title">问卷简介</div>
      <div class="description_cont" v-text="detailInfo.introduction"></div>
    </div>
    <div class="questionnaire_description_box" v-if="detailInfo.description.length>0">
      <div class="description_title">问卷详情</div>
      <div class="description_cont" v-html="detailInfo.description"></div>
    </div>
    <div class="operate_box" v-if="detailInfo.status == 2">
      <span class="operate_btn btn_disabled" v-if="detailInfo.isSubmittedAnswer">您已提交过问卷</span>
      <span class="operate_btn" v-else-if="detailInfo.involvementNumber>0 && remainNum>0" @click="enterQuestionnaire">进入问卷<span class="remain_seats">( 剩余 <span v-text="remainNum"></span> 席位 )</span></span>
      <span class="operate_btn btn_disabled" v-else-if="detailInfo.involvementNumber>0 && remainNum<=0">进入问卷<span class="remain_seats">( 剩余 <span v-text="remainNum"></span> 席位 )</span></span>
      <span class="operate_btn" v-else @click="enterQuestionnaire">进入问卷</span>
    </div>
    <van-popup :style="{ width: '85%', borderRadius: '10px' }" v-model="showMultiagentSelect">
      <div class="department_select_box">
        <div class="department_select_label">答卷人所属主体</div>
        <div class="department_form_item">
          <div class="department_form_item_title">
            <van-cell is-link title="所属主体" @click="showDepartmentSelect()" />
          </div>
          <div class="department_form_item_body">
            <input class="department_input_text" v-model="department" type="text" placeholder="请选择" disabled />
          </div>
        </div>
        <div class="department_select_operate">
          <span class="operate_btn" v-if="detailInfo.involvementNumber>0 && remainNum>0" @click="confirmEnterQuestionnaire">确认信息，进入问卷<span>( 剩余 <span v-text="remainNum"></span> 席位 )</span></span>
          <span class="operate_btn btn_disabled" v-else-if="detailInfo.involvementNumber>0 && remainNum<=0">确认信息，进入问卷<span>( 剩余 <span v-text="remainNum"></span> 席位 )</span></span>
          <span class="operate_btn" v-else @click="confirmEnterQuestionnaire">确认信息，进入问卷</span>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar title="请选择" :columns="mainBodyList" value-key="text" @cancel="showPicker = false" @confirm="onCascadeSelectConfirm" />
    </van-popup>
  </div>
</template>
<script>
import { deepClone } from "@/utils";
export default {
  name: "Detail",
  props: {
    detail: {
      type: Object,
      default: null,
    },
    mainBodyList: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      detailInfo: null, // 问卷详情
      showMultiagentSelect: false, // 是否显示多主体弹窗
      showPicker: false, // 是否显示多主体选择弹窗
      department: "", // 选择的多主体
    };
  },
  computed: {
    /* 剩余席位 */
    remainNum() {
      return this.detailInfo.involvementNumber - this.detailInfo.participateNumber;
    }
  },
  watch: {
    detail: {
      handler(newValue, oldValue) {
        this.detailInfo = deepClone(newValue);
      },
      deep: true,
    },
  },

  methods: {
    /* 进入问卷 */
    enterQuestionnaire() {
      // 是否支持多主体
      if (this.detailInfo.isMultiagent) {
        this.showMultiagentSelect = true;
      } else {
        this.$emit("enterSubjects", true);
      }
    },
    /* 确认信息，进入问卷 */
    confirmEnterQuestionnaire() {
      if (this.department == "") {
        this.$toast({
          message: "请选择所属主体",
          position: "center",
        });
        return;
      } else {
        this.showMultiagentSelect = false;
        this.$emit("enterSubjects", true);
      }
    },
    /* 弹出选择主体弹窗 */
    showDepartmentSelect() {
      this.showPicker = true;
    },
    /* 选择主体 */
    onCascadeSelectConfirm(value, index) {
      if (value[1].length > 0) {
        this.department = value.join("，");
        let id = this.mainBodyList[index[0]].children[index[1]].id
        this.$emit("setMainbodyId", id);
      } else {
        this.department = value[0];
        let id = this.mainBodyList[index[0]].id
        this.$emit("setMainbodyId", id);
      }
      this.showPicker = false;
    },
  },
  created() {
    this.detailInfo = deepClone(this.detail);
  },
};
</script>
<style scoped lang="scss">
.questionnaire_detail_box {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  &.show_operate {
    height: calc(100% - 50px);
  }
  .questionnaire_pic {
    img {
      display: block;
      width: 100%;
    }
  }
  .detail_box {
    padding: 15px;
    background-color: #fff;
    .questionnaire_title {
      width: 100%;
      padding-bottom: 10px;
      line-height: 28px;
      font-size: 18px;
      font-weight: bold;
    }
    .questionnaire_comp {
      line-height: 20px;
      padding: 0 0 10px;
      .part_num {
        color: #a6a6a6;
        font-size: 12px;
        .tj-svg-icon {
          margin-right: 5px;
          font-size: 18px;
        }
      }
      .questionnaire_status {
        float: right;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 5px;
        font-size: 12px;
        color: #fff;
        &.ongoing {
          background: #e43732;
        }
        &.over {
          background: rgba(0, 0, 0, 0.5);
        }
        &.not_start {
          background: #00a250;
        }
      }
    }
    .questionnaire_time {
      line-height: 24px;
      padding: 5px 0;
      .time {
        .tj-svg-icon {
          color: #a6a6a6;
          margin-right: 5px;
          font-size: 18px;
        }
        span {
          color: #666;
        }
      }
    }
  }
  .questionnaire_description_box {
    padding: 15px;
    margin-top: 5px;
    background-color: #fff;
    .description_title {
      position: relative;
      line-height: 30px;
      padding-left: 15px;
      margin-bottom: 5px;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      &::before {
        position: absolute;
        left: 0;
        top: 7px;
        display: block;
        width: 4px;
        height: 16px;
        background-color: #397ef5;
        content: "";
      }
    }
    .description_cont {
      line-height: 24px;
      text-align: justify;
      /deep/p {
        margin-bottom: 10px;
        max-width: 100%;
        img {
          display: block;
          max-width: 100%;
        }
        video {
          display: block;
          width: 100%;
        }
      }
      /deep/img {
        display: block;
        max-width: 100%;
      }
      /deep/video {
        display: block;
        width: 100%;
      }
    }
  }
  .operate_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    width: 100%;
    height: 50px;
    padding: 5px 5px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .operate_btn {
      flex: 1;
      height: 40px;
      line-height: 40px;
      background-color: #397ef5;
      margin-left: 5px;
      margin-right: 5px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      &.btn_disabled{
        opacity: 0.5;
      }
      .remain_seats {
        margin-left: 5px;
        font-size: 12px;
      }
    }
  }
  .department_select_box {
    padding: 15px;
    .department_select_label {
      color: #2470e5;
      font-size: 15px;
      font-weight: bold;
    }
    .department_form_item {
      margin-top: 10px;
      .department_form_item_title {
        line-height: 36px;
        color: #333;
        font-size: 18px;
        .van-cell {
          line-height: 36px;
          padding: 0;
          background-color: #fff;
          color: #333;
          font-size: 18px;
          &:hover,
          &:active {
            background-color: #fff;
          }
          .van-icon.van-cell__right-icon {
            height: 36px;
            line-height: 36px;
          }
        }
      }
      .department_form_item_body {
        .department_input_text {
          color: #333;
          width: 100%;
          padding: 5px 0px;
          margin-bottom: 10px;
          border: none;
          &:disabled {
            background: none;
          }
        }
      }
    }
    .department_select_operate {
      display: flex;
      width: 100%;
      height: 50px;
      padding: 5px 0;
      .operate_btn {
        flex: 1;
        height: 32px;
        line-height: 32px;
        background-color: #397ef5;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 5px;
      }
    }
  }
}
</style>